/**
 * Группа спортсмена с учётом удаления групп.
 *
 * Удаление группы мягкое: группа пропадает из списка групп, а `group_id`
 * спортсмена остаётся ссылкой на неё (данные не трогаем - это история). Для
 * показа такой спортсмен - без группы: попадает в фильтр «Без группы» и нигде
 * не числится в удалённой группе.
 *
 * groups - список групп направления (удалённых в нём нет). Пока он не
 * загружен (undefined), ссылка берётся как есть: нельзя отличить удалённую
 * группу от ещё не пришедшей.
 */
export function liveGroupId(
  groupId: string | null | undefined,
  groups: readonly { id: string }[] | undefined,
): string | undefined {
  if (!groupId) return undefined
  if (!groups) return groupId
  return groups.some((g) => g.id === groupId) ? groupId : undefined
}
